import React from 'react';
import * as Ui from './styles';

export function Empty({ text }) {
  return (
    <Ui.Content>
      <Ui.Text>{text}</Ui.Text>
    </Ui.Content>
  );
}
